<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="barcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Barcode </th>
        <td mat-cell *matCellDef="let row"> {{row.instrument.nr_Barcode}} </td>
    </ng-container>

    <ng-container matColumnDef="soort">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Soort </th>
        <td mat-cell *matCellDef="let row"> {{row.instrument.soort}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let row"> {{row.instrument.type}} </td>
    </ng-container>

    <ng-container matColumnDef="merk">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Merk </th>
        <td mat-cell *matCellDef="let row"> {{row.instrument.merk}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let row"> {{getStatus(row.status)}}  </td>
    </ng-container>

    <ng-container matColumnDef="certificaat">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Certificaat </th>
        <td mat-cell *matCellDef="let row"> {{row.certificaat}}  </td>
    </ng-container>

    <ng-container matColumnDef="datumPublicatie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Publicatie </th>
        <td mat-cell *matCellDef="let row"> {{row.datumPublicatie | date}} </td>
    </ng-container>
    
</mg-table>
